import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import AssetImage from '../../../../components/Assets/AssetImage';
import ASSET_TYPES from '../types/AssetTypes';

/**
 * @typedef {import('../types/ContentItems').ContentItem} ContentItem
 */

/**
 * Renders a thumbnail image for a given asset using the AssetImage component.
 * Memoizes the rendered component to optimize performance and prevent unnecessary re-renders.
 * @param {ContentItem} asset - The asset object containing id, type, name, etc.
 * @param {boolean} draggable - Whether the thumbnail is draggable.
 */
function Thumbnail({ asset, draggable }) {
  draggable = draggable || false;

  return React.useMemo(() => {
    asset = clone(asset);

    if (asset.type === ASSET_TYPES.playlist) {
      // in mid wizard flow, playlist entries may not have asset_id but fileId instead,
      // and we need to normalize it for AssetImage to work correctly
      const entries = asset.playlistEntries || asset.files || [];

      asset.playlistEntries = entries.map(entry => {
        entry.asset_id = entry.assetId || entry.fileId || entry.id;

        return entry;
      });
    }

    return <AssetImage id={asset.id} type={asset.type} item={asset} draggable={draggable} />;
  }, [asset.id, asset.type, draggable]);
}

Thumbnail.propTypes = {
  asset: PropTypes.object.isRequired,
  draggable: PropTypes.bool,
};

export default Thumbnail;
